import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { conformToMask } from 'angular2-text-mask';
import { Masks } from './masks';

export function cpfValidator(control: AbstractControl): ValidationErrors | null {
    var re = new RegExp(/[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/g);

    var conformedCPF = conformToMask(
        control.value,
        Masks.cpf,
        { guide: false }
    )

    if (conformedCPF.conformedValue != undefined && conformedCPF.conformedValue != null && conformedCPF.conformedValue != '' && !re.test(conformedCPF.conformedValue))
        return {
            cpf: true,
            mensagem:(campo:string)=>`O campo <b>${campo}</b> não é um CPF válido`
        }
    return null;
}

